import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import './pages/pages.css';
import Login from './pages/Login';
import SetupStudio from './pages/SetupStudio';
import Dashboard from './pages/Dashboard';
import Lavoratori from './pages/Lavoratori';
import Clienti from './pages/Clienti';
import ConfigEmail from './pages/ConfigEmail';
import Comunicazioni from './pages/Comunicazioni';
import Statistiche from './pages/Statistiche';

function ProtectedRoute({ children }) {
  const { utente, caricamento } = useAuth();
  if (caricamento) return <div style={{ padding: '2rem', textAlign: 'center' }}>Caricamento...</div>;
  return utente ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { utente, caricamento } = useAuth();
  if (caricamento) return <div style={{ padding: '2rem', textAlign: 'center' }}>Caricamento...</div>;
  return utente ? <Navigate to="/" /> : children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/setup" element={<PublicRoute><SetupStudio /></PublicRoute>} />
      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/clienti" element={<ProtectedRoute><Clienti /></ProtectedRoute>} />
      <Route path="/lavoratori" element={<ProtectedRoute><Lavoratori /></ProtectedRoute>} />
      <Route path="/comunicazioni" element={<ProtectedRoute><Comunicazioni /></ProtectedRoute>} />
      <Route path="/email" element={<ProtectedRoute><ConfigEmail /></ProtectedRoute>} />
      <Route path="/statistiche" element={<ProtectedRoute><Statistiche /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
